import PCFull from './full.vue';
import MobFull from '@rebuild/materials/shared/analyst/MobFull.vue';

export const componentMap = {
	full: PCFull,
	'mob-full': MobFull
};
